<script>
import {
  pageMonCompteMaFideliteProps,
  usePageMonCompteMaFidelite
} from "./mixin";
import Badge from "@/components/atoms/badge";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import Card from "@/components/molecules/card";
import ButtonSwitch from "@/components/molecules/button-switch";
import Titre from "@/components/atoms/titre";
import Alert from "@/components/molecules/alert";
import LazyImage from "@/components/atoms/lazy-image";
import CartesFideliteComparatif from "@/containers/mon-compte/ma-fidelite/carte-fidelite-comparatif/index.vue";
import FidelityCard from "@/containers/mon-compte/ma-fidelite/ma-carte-fidelite/index.vue";

import bienvenueFid from "@/assets/images/bienvenue-fid.svg";

export default {
  name: "MonEspaceFideliteMobile",
  components: {
    Badge,
    Icon,
    Button,
    Card,
    ButtonSwitch,
    Titre,
    Alert,
    LazyImage,
    CartesFideliteComparatif,
    FidelityCard
  },
  props: {
    ...pageMonCompteMaFideliteProps()
  },
  setup(props) {
    const { malinCard, coraCard, hasNoCard, getTodayDate } =
      usePageMonCompteMaFidelite(props);

    return { malinCard, coraCard, hasNoCard, getTodayDate, bienvenueFid };
  },
  data() {
    return {
      typeCarte: 0
    };
  },
  computed: {
    hasBothCards() {
      return this.coraCard.id && this.malinCard.id;
    }
  }
};
</script>

<template>
  <div>
    <template v-if="hasNoCard">
      <Titre
        tag="h1"
        variant="primary"
        size="md"
        class="u-mb-md u-mt-sm u-ml-sm u-mr-sm"
      >
        Mon espace fidélité
      </Titre>
      <CartesFideliteComparatif />
    </template>
    <template v-else>
      <div class="u-pl-sm u-pr-sm u-pb-md">
        <Titre
          tag="h1"
          variant="primary"
          size="md"
          class="u-mb-md u-mt-sm"
        >
          Mon espace fidélité
        </Titre>
        <Alert
          v-if="showWelcomeMessage"
          closable
          radius="md"
          padding="sm"
          variant="success-background"
          closable-icon-color="success-text"
          outline="success"
          class="u-mb-md"
        >
          <div class="u-flex u-flex-align-center">
            <LazyImage
              :src="bienvenueFid"
              width="56"
              height="56"
              class="u-flex-shrink-none u-mr-xs"
            />
            <div class="u-flex u-flex-column u-font-16 u-color-success-text">
              <p class="u-font-500">
                Votre carte de fidélité a bien été créée !
              </p>
              <p>Découvrez vos avantages dès maintenant.</p>
            </div>
          </div>
        </Alert>
        <div class="u-flex u-flex-align-center u-font-17 u-mb-sm">
          <Badge class="u-mr-sm">
            <Icon
              name="alert-circle"
              variant="primary-light"
            />
          </Badge>
          Solde au {{ getTodayDate() }}
        </div>
        <Button
          link
          to="/infos-et-services/la-carte-de-fidelite"
          variant="text-light"
        >
          En savoir plus sur le programme fidélité
        </Button>
        <div
          v-if="hasBothCards"
          class="u-text-center u-mt-md"
        >
          <ButtonSwitch
            label-left="Ma carte Malin"
            label-right="Ma carte Cora"
            :active-index="typeCarte"
            @change="typeCarte = $event"
          />
        </div>
      </div>
      <div :class="(coraCard.hasOwnProperty('id') && !malinCard.hasOwnProperty('id')) && 'u-flex u-flex-column-reverse'">
        <Card
          v-if="hasBothCards ? typeCarte === 0 : true"
          elevation="sm"
          class="u-p-md u-mb-md"
          :variant="malinCard.attributes.expired ? 'grey-5' : null"
        >
          <!-- TODO : props à supprimer en dev -->
          <FidelityCard
            :card="malinCard"
            class="u-text-center"
          />
        </Card>

        <Card
          v-if="hasBothCards ? typeCarte === 1 : true"
          elevation="sm"
          class="u-p-md u-mb-lg"
          :variant="coraCard.attributes.expired ? 'grey-5' : null"
        >
          <!-- TODO : props à supprimer en dev -->
          <FidelityCard
            :card="coraCard"
            class="u-text-center"
          />
        </Card>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
</style>
